<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="760px"
    custom-class="entry-diagnostic-dialog"
    @close="close"
  >
    <div v-if="diagnostic" class="entry-diagnostic">
      <header class="entry-diagnostic__header">
        <span>ENTRY BLOCKED</span>
        <h2>{{ diagnostic.title }}</h2>
        <p>{{ diagnostic.summary }}</p>
      </header>

      <section class="entry-diagnostic__section">
        <h3>Why entry was blocked</h3>
        <div class="entry-diagnostic__failure">
          <span aria-hidden="true">×</span>
          <div>
            <strong>{{ diagnostic.failureLabel }}</strong>
            <p>{{ diagnostic.failureDetail }}</p>
          </div>
        </div>
      </section>

      <section class="entry-diagnostic__section">
        <h3>Exam entry summary</h3>
        <dl class="entry-diagnostic__summary">
          <div v-for="(row, index) in diagnostic.rows" :key="index">
            <dt>{{ row.label }}</dt>
            <dd>{{ row.value }}</dd>
          </div>
        </dl>
      </section>

      <div class="entry-diagnostic__reference">
        Screenshot this summary for support · Reference: {{ diagnostic.reference }}
      </div>
      <footer class="entry-diagnostic__actions">
        <report-problem-button
          button-text="Report problem"
          :context="reportContext"
          :template-name="templateName"
        />
        <el-button type="primary" @click="close">Close</el-button>
      </footer>
    </div>
  </el-dialog>
</template>

<script>
import ReportProblemButton from "../../Support/ReportProblemButton.vue";

export default {
  name: "ExamEntryDiagnosticDialog",
  components: {
    ReportProblemButton,
  },
  props: {
    visible: { type: Boolean, default: false },
    diagnostic: { type: Object, default: null },
  },
  computed: {
    reportContext() {
      if (!this.diagnostic) return null;
      return {
        page: "list",
        blocked_code: this.diagnostic.reason || "",
        blocked_reason: this.diagnostic.title || "",
        summary: this.diagnostic.summary || "",
        failure: this.diagnostic.failureLabel || "",
        failure_detail: this.diagnostic.failureDetail || "",
        reference: this.diagnostic.reference || "",
      };
    },
    templateName() {
      const reference = this.diagnostic && this.diagnostic.reference
        ? String(this.diagnostic.reference)
        : "";
      return reference ? reference.split("/")[1] || "" : "";
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style>
.entry-diagnostic-dialog {
  max-width: calc(100vw - 32px);
  margin-top: 5vh !important;
  border-radius: 14px;
  overflow: hidden;
}
.entry-diagnostic-dialog .el-dialog__header { display: none; }
.entry-diagnostic-dialog .el-dialog__body { max-height: 90vh; padding: 0; overflow-y: auto; }
</style>

<style lang="scss" scoped>
.entry-diagnostic { color: #1b213d; background: #f7f8fc; }
.entry-diagnostic__header {
  padding: 24px 30px;
  color: #fffaf7;
  background: #9f2f25;
  span { font-size: 12px; font-weight: 700; letter-spacing: 0.12em; }
  h2 { margin: 6px 0 8px; color: inherit; font-size: 28px; line-height: 1.2; }
  p { margin: 0; font-size: 14px; line-height: 1.55; }
}
.entry-diagnostic__section {
  padding: 20px 30px 0;
  h3 { margin: 0 0 10px; color: #273161; font-size: 17px; }
}
.entry-diagnostic__failure {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 12px;
  padding: 10px 0;
  border-block: 1px solid #dfe3ef;
  > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #93291f;
    background: #f9dfdc;
    font-weight: 700;
  }
  strong { color: #273161; font-size: 14px; }
  p { margin: 4px 0 0; color: #596174; font-size: 13px; line-height: 1.5; }
}
.entry-diagnostic__summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 24px;
  margin: 0;
  border-top: 1px solid #dfe3ef;
  > div { min-width: 0; padding: 9px 0; border-bottom: 1px solid #dfe3ef; }
  dt { color: #6a7184; font-size: 12px; font-weight: 600; }
  dd { margin: 4px 0 0; font-size: 13px; line-height: 1.45; overflow-wrap: anywhere; }
}
.entry-diagnostic__reference {
  margin: 18px 30px 0;
  color: #6f7688;
  font-family: monospace;
  font-size: 11px;
  overflow-wrap: anywhere;
}
.entry-diagnostic__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 16px 30px 22px;
}
@media (max-width: 640px) {
  .entry-diagnostic__summary { grid-template-columns: 1fr; }
}
</style>
